module.exports = __webpack_public_path__ + "static/img/bz.49323c5b.svg";